/* eslint-disable global-require */
import gsap from "gsap";
import { ensureFirebaseAuth, db, getDownloadUrl } from "../../db";
import { generateProjectModal } from "../projectPodiums";

export default class SubwayEnvironment {
  constructor(models) {
    this.models = models;
    this.hasMetrocard = false;
    this.inSubway = false;

    this._init();
  }

  async _init() {
    ensureFirebaseAuth();

    db.collection("project_configs")
      .doc("sunset-metro")
      .onSnapshot((doc) => {
        this.config = doc.data();
      });

    db.collection("projectPodiums")
      .doc("sunsetMetro")
      .onSnapshot((doc) => {
        this.projectInfo = doc.data();
        this.projectInfo.imagePath = getDownloadUrl(
          this.projectInfo.imageBucketPath
        );
      });
  }

  checkInteractions(cameraPosition) {
    const ticketMachine = this.models.multiQualityModels["mta_machine"];
    if (ticketMachine && ticketMachine.active && !this.hasMetrocard) {
      if (cameraPosition.distanceTo(ticketMachine.positionVector) < 2) {
        this.hasMetrocard = true;
        this.triggerTicketMachineInteraction();
      }
    }

    const subwayEntrance = this.models.multiQualityModels["subway_entrance"];
    if (subwayEntrance && subwayEntrance.active) {
      if (cameraPosition.distanceTo(subwayEntrance.positionVector) < 10) {
        if (!this.inSubway) {
          this.triggerSubwayInteraction(this.hasMetrocard);
          this.inSubway = true;
        }
      } else {
        this.inSubway = false;
      }
    }
  }

  triggerSubwayInteraction(hasMetrocard) {
    if (!hasMetrocard) {
      generateProjectModal({
        ...this.projectInfo,
        author: "Huiyi Chen, Jesse Simpson, Anthony Bui",
        description:
          "HMM... it seems you forgot your Metro Card. You can't enter the subway without your Metro Card! I think there's an MTA machine nearby...",
      });
    } else {
      generateProjectModal({
        ...this.projectInfo,
        link: "https://www.sunsetmetro.world",
        linkTitle: "Enter the Subway Station",
        description: `When was the last time you took the subway?
          For many, this break in routine has been missed.
          Fortunately, Sunset Metro is leaving from Yorb every 10 minutes!

          NOTE: This is a 10-15 min live experience.`,
      });
    }
  }

  triggerTicketMachineInteraction() {
    const el = document.getElementById("metrocard-status-image");

    el.classList.add("active");
    gsap.from(el, {
      duration: 3,
      scale: 3,
      y: 100,
      ease: "elastic.out(1, 0.3)",
    });
  }
}
